import React from 'react';
import { useI18n } from '../../i18n/I18nContext';

type PageKey = keyof ReturnType<typeof useI18n>['content']['pageHeaders'];

const PageHeader: React.FC<{ page: PageKey }> = ({ page }) => {
  const { content } = useI18n();
  const header = content.pageHeaders[page];

  return (
    <header className="static-page__hero">
      <div className="container">
        <span className="section-label">{header.label}</span>
        <h1 className="static-page__title">{header.title}</h1>
        <p className="static-page__subtitle">{header.subtitle}</p>
      </div>
    </header>
  );
};

export default PageHeader;
